import { Component, OnInit } from '@angular/core';
import { Cart, CartClient, PaymentClient, PaymentDTO, PaymentInfo, User } from '../Services/WOWApi.Service';
import { CartObject, Seats } from '../Services/cart-object';
import { CustomServiceService } from '../Services/custom-service.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { CommonServices } from '../Common/CommonServices';
import { openConfirmDialog } from '../confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css'],
  standalone: false
})
export class CartComponent implements OnInit {
  showSpinner: boolean = false;
  paymentInfoDto: PaymentDTO = null;
  paymentInfo: PaymentInfo;
  IsTransCompleted: boolean = false;
  loggedUser: User;
  TransId: string;
  cart: Cart;
  cartObject: CartObject;
  TotalCost: number = 0;
  cartDetails: CartObject[];
  displayedColumns: string[] = ['ProductName', 'Quantity', "Cost", "Total", "Remove"];
  isMobileView = false;
  subscription: Subscription;
  isCheckoutClicked = false;
  cartRemainingTime = '';
  totalCost = [];
  currentSurfedWebinarId: number;
  isShippingAddressAvailable!: boolean;
  constructor(
    private cartClient: CartClient,
    private paymentClient: PaymentClient,
    private customServices: CustomServiceService,
    private commonServices: CommonServices,
    private commonService: CommonService,
    private router: Router,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.commonService.currentWebinarSurfed.subscribe(id => {
      if (id != null && id !== 0) {
        this.currentSurfedWebinarId = id;
      }
    })
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.showSpinner = true;
    this.loggedUser = this.customServices.GetLoggedInUser();
    this.subscription = this.commonService.userCart.subscribe(userCart => {
      this.cart = userCart;
      this.ProcessData();
      this.showSpinner = false;
    });
    this.subscription = this.commonService.cartExpireRemainingTime.subscribe(remainingTime => this.cartRemainingTime = remainingTime);
    this.getShippingAddress();
  }
  public ProcessData() {
    this.cartDetails = [];
    this.totalCost = [];
    this.cart.cartDetails.forEach(element => {
      this.cartObject = null;
      if (this.cartDetails.filter(x => x.productName == element.webinar.name).length > 0) {
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].total = this.cartDetails.filter(x => x.productName == element.webinar.name)[0].total + element.webinar.pricePerSeat;
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].quantity = this.cartDetails.filter(x => x.productName == element.webinar.name)[0].quantity + 1;
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].message = this.cartDetails.filter(x => x.productName == element.webinar.name)[0].message + " ," + element.seatNumber;
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].seatNumber.push(element.seatNumber);
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].seatId.push(element.seatId);
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].seats.push({ seatId: element.seatId, seatNumber: Number(element.seatNumber) });
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].pricePerSeat = element.webinar.pricePerSeat;
        this.cartDetails.filter(x => x.productName == element.webinar.name)[0].cartId = element.cartId;
      }
      else {
        this.cartObject = new CartObject();
        this.cartObject.productName = element.webinar.name;
        this.cartObject.roomName = element.webinar.room.roomName;
        this.cartObject.cost = element.webinar.pricePerSeat;
        this.cartObject.total = element.webinar.pricePerSeat;
        this.cartObject.quantity = 1;
        this.cartObject.message = "Seat Number - " + element.seatNumber;
        this.cartObject.seatNumber.push(element.seatNumber);
        this.cartObject.seatId.push(element.seatId);
        this.cartObject.webinarId = element.webinarId;
        this.cartObject.seats.push({ seatId: element.seatId, seatNumber: Number(element.seatNumber) });
        this.cartObject.pricePerSeat = element.webinar.pricePerSeat;
        this.cartObject.cartId = element.cartId;
        this.cartDetails.push(this.cartObject);
      }
    });
    this.cartDetails.map(x => {
      this.totalCost.push({ totalCost: x.total, webinarId: x.webinarId });
    });
    console.log(this.cartDetails)
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 200)

  }

  // calculateTotal() {
  //   this.TotalCost =0;
  //   this.cart.cartDetails.forEach(x =>{
  //     this.TotalCost = this.TotalCost + x.webinar.pricePerSeat;
  //   }) 
  //   return this.TotalCost;
  // }

  cartTotalCost() {
    let cost = 0;
    this.cartDetails.map(x => {
      cost += x.pricePerSeat * x.seats.length;
    });
    return cost;
  }

  isAllFreeBeeWebinars(): boolean {
    if (!this.cart || !this.cart.cartDetails || this.cart.cartDetails.length === 0) {
      return false;
    }
    return this.cart.cartDetails.every(item => item.webinar && item.webinar.isFreeBee === true);
  }

  purchaseFreeBeeWebinars() {
    if (!this.isAllFreeBeeWebinars()) {
      this.commonServices.showMessage('Error', 'This action is only available for freebie webinars.', 5);
      return;
    }

    this.showSpinner = true;
    this.cartClient.purchaseFreeBeeWebinars(this.loggedUser.id).subscribe(
      response => {
        this.showSpinner = false;
        if (response.isOrderPlaced) {
          this.commonServices.showMessage('Success', 'Freebie webinar seats purchased successfully!', 5);
          // Clear cart and refresh
          this.commonService.setUserCart({ cartId: 0, cartName: '', userId: this.loggedUser.id, cartDetails: [] });
          this.router.navigate(['/MyAccount']);
        } else {
          this.commonServices.showMessage('Error', response.message || 'Failed to purchase freebie webinars.', 5);
        }
      },
      error => {
        this.showSpinner = false;
        this.commonServices.showMessage('Error', error.error || 'Failed to purchase freebie webinars.', 5);
      }
    );
  }

  // Checkout()
  // {
  //   this.isCheckoutClicked = true;
  //   render({
  //     id : "#paypalGateway",
  //     currency : "USD",
  //     value : this.cartTotalCost().toString(),
  //     onApprove : (details) => {
  //       this.showSpinner = true;
  //       this.paymentInfoDto = new PaymentDTO();
  //       var paymentInfo = new PaymentInfo();
  //       paymentInfo.transactionId = details.id;
  //       paymentInfo.paymentStatusId = details.status;
  //       paymentInfo.paymentTime = new Date(details.create_time);
  //       paymentInfo.amount =  parseInt(details.purchase_units[0].amount.value);
  //       paymentInfo.currency = details.purchase_units[0].amount.currency_code;
  //       paymentInfo.comments = JSON.stringify(details);
  //       paymentInfo.paymentMode = "Paypal" ;
  //       this.paymentInfoDto.paymentInfo = paymentInfo;
  //       this.paymentInfoDto.cartDetail = this.cart.cartDetails;
  //       this.paymentClient.savePayment(this.loggedUser.id , this.paymentInfoDto).subscribe(x =>{
  //         this.showSpinner = false;
  //         this.IsTransCompleted = true;
  //         this.paymentInfo = x;
  //         console.log(x);
  //         this.cartDetails = [];
  //         this.isCheckoutClicked = false;

  //       }, error => {
  //         this.isCheckoutClicked = false;
  //       });

  //     }
  //   });
  //   setTimeout(() => {
  //     window.scrollTo({top: 30000, left: document.body.scrollHeight, behavior: 'smooth'});
  //   }, 200)
  // }

  deleteCartSeat(seatId: number, webinarId: number, cartId: number) {
    console.log(seatId, webinarId, cartId);
    if (seatId === undefined || seatId === null || webinarId === undefined || webinarId === null || cartId === undefined || cartId === null) {
      this.commonServices.showMessage("Error", "seatId, webinarId & cartId are mandatory.");
      return;
    }
    const cartDetails = JSON.parse(JSON.stringify(this.cartDetails));
    const cartItem: CartObject = cartDetails.find(x => x.webinarId === webinarId);
    const seatItem: Seats = cartItem.seats.find(x => x.seatId === seatId);

    openConfirmDialog(this.dialog, {
        message: `Remove seat ${seatItem.seatNumber} from ${cartItem.productName}?`,
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.showSpinner = true;
        this.cartClient.deleteCartSeat(seatId, webinarId, cartId).subscribe(res => {
          if (res === true) {
            this.commonServices.showMessage("Success", `Seat number ${seatItem.seatNumber} deleted successfully.`);
            this.processCartDeleteAfterSuccess('seatDelete', webinarId, seatId);
          } else {
            location.reload();
          }
          this.showSpinner = false;
        }, error => {
          this.commonServices.showMessage("Error", `${error.error}`);
          this.showSpinner = false;
        });
      }
    })
  }

  deleteWebinarWithAllSeats(webinarId: number, cartId: number) {
    if (webinarId === undefined || webinarId === null || cartId === undefined || cartId === null) {
      this.commonServices.showMessage("Error", "seatId, webinarId & cartId are mandatory.");
      return;
    }
    openConfirmDialog(this.dialog, {
        message: 'Remove all seats in this listing from your cart?',
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.showSpinner = true;
        this.cartClient.deleteCartItemWithAllSeats(webinarId, cartId).subscribe(res => {
          if (res === true) {
            this.commonServices.showMessage("Success", `Webinar Seats deleted successfully.`);
            this.processCartDeleteAfterSuccess('fullCartItemDelete', webinarId);
          } else {
            location.reload();
          }
          this.showSpinner = false;
        }, error => {
          this.commonServices.showMessage("Error", `${error.error}`);
          this.showSpinner = false;
        })
      }
    })
  }

  processCartDeleteAfterSuccess(type: string, webinarId: number, seatId?: number) {
    const cartDetails = JSON.parse(JSON.stringify(this.cartDetails));
    const cartItem: CartObject = cartDetails.find(x => x.webinarId === webinarId);
    const cartItemIdx = cartDetails.findIndex(x => x.webinarId === webinarId);
    if (type === 'seatDelete') {
      if (seatId == undefined || seatId === null) {
        this.commonServices.showMessage('Error', `Seat Id is mandatory`);
        return;
      }
      const seatIdx = cartItem.seats.findIndex(x => x.seatId === seatId);
      cartItem.seats.splice(seatIdx, 1);
      if (cartItem.seats.length > 0) {
        cartDetails[cartItemIdx] = cartItem;
      } else {
        cartDetails.splice(cartItemIdx, 1);
      }
      // udpate cart in common service
      const cartSeatIdx = this.cart.cartDetails.findIndex(x => x.seatId === seatId);
      this.cart.cartDetails.splice(cartSeatIdx, 1);
      if (cartDetails.length === 0) {
        this.cart.cartDetails = [];
      }
      this.commonService.setUserCart(this.cart);
    }
    if (type === 'fullCartItemDelete') {
      cartDetails.splice(cartItemIdx, 1);
      // udpate cart in common service
      const cartSeatItems = this.cart.cartDetails.filter(x => x.webinarId === webinarId);
      cartSeatItems.map(x => {
        const cartSeatIdx = this.cart.cartDetails.findIndex(x => x.seatId === x.seatId);
        this.cart.cartDetails.splice(cartSeatIdx, 1);
      });
      if (cartDetails.length === 0) {
        this.cart.cartDetails = [];
      }
      this.commonService.setUserCart(this.cart);
    }
    this.cartDetails = cartDetails;
  }

  initiatPayment() {
    this.commonService.setCartDetails(this.cartDetails);
    this.router.navigateByUrl('/veem-payment');
  }

  goToWebinars() {
    this.commonService.currentWebinarSurfed.subscribe(id => {
      if (id != null && id !== 0) {
        this.router.navigateByUrl(`/Webinar/${this.currentSurfedWebinarId}`);
      }
    })
  }

  getShippingAddress() {
    this.subscription = this.commonService.communicationMethods.subscribe(response => {
      if (response != null && response.phone != null && response.phone !== '' && response.phone > 0 && response.email != null && response.email !== '') {
        this.isShippingAddressAvailable = true;
      } else {
        this.isShippingAddressAvailable = false;
      }
    }, error => {
      this.commonServices.showMessage('error', 'Error found wile fetching communication methods', 5);
    });
  }

  onGotToUpdateShippingAddress() {
    this.router.navigateByUrl('/MyAccount/2');
  }

  cartWebinarWisetotalCost(webinarId: number) {
    return this.totalCost.find(x => x.webinarId === webinarId).totalCost;
  }
}
